// Hindi translations
export const hi: Record<string, string> = {
  // ==================== COMMON ====================
  'common.loading': 'लोड हो रहा है...',
  'common.error': 'एक त्रुटि हुई',
  'common.retry': 'पुनः प्रयास करें',
  'common.cancel': 'रद्द करें',
  'common.save': 'सहेजें',
  'common.continue': 'जारी रखें',
  'common.back': 'वापस',
  'common.next': 'अगला',
  'common.skip': 'छोड़ें',
  'common.done': 'हो गया',
  'common.yes': 'हाँ',
  'common.no': 'नहीं',
  'common.ok': 'ठीक है',
  'common.check': 'जाँचें',
  'common.correct': 'सही!',
  'common.incorrect': 'गलत',
  'common.tryAgain': 'पुनः प्रयास करें',
  'common.start': 'शुरू करें',
  'common.finish': 'समाप्त',
  'common.submit': 'जमा करें',

  // ==================== NAVIGATION ====================
  'nav.home': 'होम',
  'nav.courses': 'कोर्स',
  'nav.vocabulary': 'शब्दावली',
  'nav.profile': 'प्रोफ़ाइल',
  'nav.settings': 'सेटिंग्स',
  'nav.logout': 'लॉग आउट',
  'nav.leaderboard': 'लीडरबोर्ड',
  'nav.aiTutor': 'AI ट्यूटर',

  // ==================== ONBOARDING ====================
  'onboarding.welcome': 'KoreanFlow में आपका स्वागत है!',
  'onboarding.selectLanguage': 'अपनी भाषा चुनें',
  'onboarding.selectLanguageDesc': 'ऐप इंटरफ़ेस के लिए भाषा चुनें',
  'onboarding.selectGoal': 'आपका सीखने का लक्ष्य क्या है?',
  'onboarding.selectGoalDesc': 'हम आपके लिए सीखने का रास्ता बनाएंगे',
  'onboarding.takeTest': 'लेवल टेस्ट दें',
  'onboarding.takeTestDesc': '5 मिनट में अपना कोरियाई स्तर जानें',
  'onboarding.skipTest': 'अभी छोड़ें',
  'onboarding.skipTestDesc': 'शुरुआत से शुरू करें',
  'onboarding.letsGo': 'चलो शुरू करें!',
  'onboarding.step': 'चरण',
  'onboarding.of': 'का',

  // ==================== LEVEL TEST ====================
  'levelTest.title': 'लेवल टेस्ट',
  'levelTest.subtitle': 'आइए आपका कोरियाई स्तर जानें',
  'levelTest.duration': 'लगभग 5 मिनट',
  'levelTest.questions': 'प्रश्न',
  'levelTest.vocabulary': 'शब्दावली',
  'levelTest.grammar': 'व्याकरण',
  'levelTest.listening': 'सुनना',
  'levelTest.speaking': 'बोलना',
  'levelTest.analyzing': 'आपके परिणाम का विश्लेषण हो रहा है...',
  'levelTest.yourLevel': 'आपका स्तर',
  'levelTest.congratulations': 'बधाई हो!',
  'levelTest.resultDesc': 'आपके टेस्ट परिणामों के आधार पर',
  'levelTest.startLearning': 'सीखना शुरू करें',
  'levelTest.retakeTest': 'फिर से टेस्ट दें',
  'levelTest.sectionComplete': 'अनुभाग पूर्ण',
  'levelTest.nextSection': 'अगला अनुभाग',
  'levelTest.listenAndAnswer': 'सुनें और जवाब दें',
  'levelTest.speakNow': 'अभी बोलें',
  'levelTest.tapToListen': 'सुनने के लिए टैप करें',

  // ==================== CEFR LEVELS ====================
  'cefr.A1': 'शुरुआती',
  'cefr.A2': 'प्राथमिक',
  'cefr.B1': 'मध्यवर्ती',
  'cefr.B2': 'उच्च मध्यवर्ती',
  'cefr.C1': 'उन्नत',
  'cefr.C2': 'महारत',
  'cefr.A1.desc': 'बुनियादी अभिवादन और सरल अभिव्यक्तियाँ',
  'cefr.A2.desc': 'दैनिक जीवन के बारे में सरल बातचीत',
  'cefr.B1.desc': 'अधिकांश यात्रा स्थितियों को संभाल सकते हैं',
  'cefr.B2.desc': 'मूल वक्ताओं के साथ धाराप्रवाह बातचीत कर सकते हैं',
  'cefr.C1.desc': 'विचारों को धाराप्रवाह और स्वतःस्फूर्त रूप से व्यक्त कर सकते हैं',
  'cefr.C2.desc': 'सभी स्थितियों में लगभग मूल जैसी दक्षता',

  // ==================== LEAGUE / RANKING ====================
  'league.title': 'लीग',
  'league.weeklyRanking': 'साप्ताहिक रैंकिंग',
  'league.bronze': 'कांस्य',
  'league.silver': 'रजत',
  'league.gold': 'स्वर्ण',
  'league.platinum': 'प्लैटिनम',
  'league.diamond': 'हीरा',
  'league.promotion': 'प्रमोशन ज़ोन',
  'league.demotion': 'डिमोशन ज़ोन',
  'league.safe': 'सुरक्षित ज़ोन',
  'league.weeklyXP': 'साप्ताहिक XP',
  'league.rank': 'रैंक',
  'league.daysLeft': 'दिन बाकी',
  'league.promoted': 'प्रमोट हुए!',
  'league.demoted': 'डिमोट हुए',
  'league.stayed': 'रुके',
  'league.noData': 'अभी तक कोई रैंकिंग डेटा नहीं',
  'league.earnXP': 'लीग में शामिल होने के लिए XP कमाएं!',
  'league.topPercent': 'शीर्ष {percent}%',

  // ==================== LANDING PAGE ====================
  'landing.tagline': '#1 कोरियाई सीखने का ऐप',
  'landing.title': 'कोरियाई सीखें',
  'landing.titleAccent': 'मज़ेदार तरीके से',
  'landing.subtitle': 'छोटे पाठों, K-Pop और K-Drama सामग्री, और AI-संचालित उच्चारण फीडबैक के साथ कोरियाई में महारत हासिल करें। 10 लाख+ शिक्षार्थियों से जुड़ें!',
  'landing.getStarted': 'मुफ्त शुरू करें',
  'landing.learnMore': 'और जानें',
  'landing.login': 'लॉग इन',
  'landing.startFree': 'मुफ्त शुरू करें',
  'landing.learners': 'शिक्षार्थी',
  'landing.lessons': 'पाठ',
  'landing.countries': 'देश',

  // ==================== FEATURES ====================
  'features.title': 'KoreanFlow क्यों?',
  'features.subtitle': 'हमारा अनूठा दृष्टिकोण गेमिफिकेशन, प्रामाणिक सामग्री और AI तकनीक को जोड़ता है ताकि कोरियाई सीखना मज़ेदार और प्रभावी हो।',
  'features.streaks.title': 'दैनिक स्ट्रीक्स',
  'features.streaks.desc': 'दैनिक लक्ष्यों और स्ट्रीक पुरस्कारों के साथ आदत बनाएं। XP और जेम्स के साथ प्रेरित रहें।',
  'features.folksong.title': 'लोक गीत',
  'features.folksong.desc': 'पारंपरिक लोक गीतों के माध्यम से कोरियाई सीखें। गीत और संस्कृति को समझें!',
  'features.culture.title': 'कोरियाई संस्कृति',
  'features.culture.desc': 'कहावतें, स्लैंग और आवश्यक वाक्यांश खोजें। प्रामाणिक अभिव्यक्तियों में महारत हासिल करें।',
  'features.ai.title': 'AI चैटबॉट',
  'features.ai.desc': 'हमारे AI ट्यूटर के साथ बातचीत का अभ्यास करें। तत्काल प्रतिक्रिया और सुधार पाएं।',
  'features.leaderboard.title': 'लीडरबोर्ड',
  'features.leaderboard.desc': 'दोस्तों और दुनिया भर के शिक्षार्थियों के साथ प्रतिस्पर्धा करें। साप्ताहिक रैंकिंग में ऊपर चढ़ें!',
  'features.srs.title': 'SRS शब्दावली',
  'features.srs.desc': 'स्मार्ट दोहराव प्रणाली सुनिश्चित करती है कि आप जो सीखते हैं वह याद रहे। हमेशा के लिए।',
  'features.pronunciation.title': 'उच्चारण फीडबैक',
  'features.pronunciation.desc': 'विस्तृत स्कोरिंग के साथ AI-संचालित उच्चारण विश्लेषण।',

  // ==================== CTA ====================
  'cta.title': 'अपनी यात्रा शुरू करने के लिए तैयार हैं?',
  'cta.subtitle': 'लाखों शिक्षार्थियों से जुड़ें और आज ही कोरियाई बोलना शुरू करें। यह मुफ्त है!',
  'cta.button': 'मुफ्त सीखना शुरू करें',

  // ==================== AUTH ====================
  'auth.login': 'लॉग इन',
  'auth.register': 'साइन अप',
  'auth.email': 'ईमेल',
  'auth.emailPlaceholder': 'अपना ईमेल दर्ज करें',
  'auth.password': 'पासवर्ड',
  'auth.passwordPlaceholder': 'पासवर्ड बनाएं',
  'auth.confirmPassword': 'पासवर्ड की पुष्टि करें',
  'auth.forgotPassword': 'पासवर्ड भूल गए?',
  'auth.noAccount': 'खाता नहीं है?',
  'auth.haveAccount': 'पहले से खाता है?',
  'auth.orContinueWith': 'या इसके साथ जारी रखें',
  'auth.google': 'Google',
  'auth.apple': 'Apple',
  'auth.createAccount': 'खाता बनाएं',
  'auth.createAccountTitle': 'अपना खाता बनाएं',
  'auth.createAccountSubtitle': 'आज ही अपनी कोरियाई सीखने की यात्रा शुरू करें',
  'auth.username': 'यूज़रनेम',
  'auth.usernamePlaceholder': 'एक यूज़रनेम चुनें',
  'auth.usernameHint': 'केवल अक्षर, संख्याएं और अंडरस्कोर',
  'auth.passwordHint': 'कम से कम 8 अक्षर अपरकेस, लोअरकेस और संख्या के साथ',
  'auth.nativeLanguage': 'मातृभाषा',
  'auth.nativeLanguageHint': 'हम इस भाषा में स्पष्टीकरण दिखाएंगे',
  'auth.termsAgree': 'साइन अप करके, आप हमारी स्वीकार करते हैं',
  'auth.terms': 'शर्तें',
  'auth.and': 'और',
  'auth.privacyPolicy': 'गोपनीयता नीति',
  'auth.loginTitle': 'वापसी पर स्वागत है',
  'auth.loginSubtitle': 'सीखना जारी रखने के लिए साइन इन करें',
  'auth.loginButton': 'लॉग इन',
  'auth.registerButton': 'साइन अप',
  'auth.rememberMe': 'मुझे याद रखें',

  // ==================== DASHBOARD ====================
  'dashboard.welcome': 'वापसी पर स्वागत है',
  'dashboard.todayGoal': 'आज का लक्ष्य',
  'dashboard.streak': 'स्ट्रीक',
  'dashboard.days': 'दिन',
  'dashboard.xp': 'XP',
  'dashboard.level': 'स्तर',
  'dashboard.continueLearning': 'सीखना जारी रखें',
  'dashboard.recommended': 'आपके लिए अनुशंसित',
  'dashboard.myCourses': 'मेरे कोर्स',
  'dashboard.seeAll': 'सभी देखें',
  'dashboard.dailyGoalComplete': 'दैनिक लक्ष्य पूर्ण!',
  'dashboard.keepGoing': 'जारी रखें!',
  'dashboard.yourLevel': 'आपका स्तर',
  'dashboard.weeklyProgress': 'साप्ताहिक प्रगति',

  // ==================== COURSES ====================
  'courses.title': 'सभी कोर्स',
  'courses.search': 'कोर्स खोजें...',
  'courses.all': 'सभी',
  'courses.beginner': 'शुरुआती',
  'courses.elementary': 'प्राथमिक',
  'courses.intermediate': 'मध्यवर्ती',
  'courses.advanced': 'उन्नत',
  'courses.lessons': 'पाठ',
  'courses.enrolled': 'नामांकित',
  'courses.progress': 'प्रगति',
  'courses.completed': 'पूर्ण',
  'courses.recommended': 'अनुशंसित',
  'courses.forYourLevel': 'आपके स्तर के लिए',
  'courses.locked': 'लॉक',
  'courses.unlockWith': 'प्रीमियम से अनलॉक करें',

  // ==================== LESSON ====================
  'lesson.loading': 'पाठ लोड हो रहा है...',
  'lesson.notFound': 'पाठ नहीं मिला',
  'lesson.quit': 'क्या आप वाकई छोड़ना चाहते हैं? आपकी प्रगति खो जाएगी।',
  'lesson.complete': 'पाठ पूर्ण!',
  'lesson.perfect': 'परफेक्ट!',
  'lesson.amazing': 'अद्भुत! आपने सब कुछ सही किया!',
  'lesson.xpEarned': 'XP अर्जित',
  'lesson.accuracy': 'सटीकता',
  'lesson.correct': 'सही',
  'lesson.goBack': 'वापस जाएं',
  'lesson.skip': 'छोड़ें',
  'lesson.unknownType': 'अज्ञात अभ्यास प्रकार',

  // ==================== EXERCISES ====================
  'exercise.tapToReveal': 'उत्तर देखने के लिए टैप करें',
  'exercise.matchPairs': 'जोड़े मिलाएं',
  'exercise.matched': 'मिलान हुआ',
  'exercise.arrangeWords': 'शब्द व्यवस्थित करें',
  'exercise.speak': 'बोलें',
  'exercise.listening': 'सुन रहा है... अभी बोलें!',
  'exercise.processing': 'आपकी आवाज़ प्रोसेस हो रही है...',
  'exercise.tapToSpeak': 'बोलने के लिए टैप करें',
  'exercise.cantSpeak': 'अभी नहीं बोल सकते? छोड़ें',
  'exercise.again': 'फिर से',
  'exercise.gotIt': 'समझ गया!',

  // ==================== PRONUNCIATION ====================
  'pronunciation.title': 'उच्चारण अभ्यास',
  'pronunciation.subtitle': 'AI फीडबैक के साथ अपना कोरियाई उच्चारण सुधारें',
  'pronunciation.selectLevel': 'अपना स्तर चुनें',
  'pronunciation.beginner': 'शुरुआती',
  'pronunciation.intermediate': 'मध्यवर्ती',
  'pronunciation.advanced': 'उन्नत',
  'pronunciation.score': 'आपका स्कोर',
  'pronunciation.accuracy': 'सटीकता',
  'pronunciation.fluency': 'प्रवाह',
  'pronunciation.intonation': 'स्वरमान',
  'pronunciation.feedback': 'प्रतिक्रिया',
  'pronunciation.tryAgain': 'पुनः प्रयास करें',
  'pronunciation.next': 'अगला',
  'pronunciation.listen': 'सुनें',
  'pronunciation.slow': 'धीमा',
  'pronunciation.sessionComplete': 'सत्र पूर्ण!',
  'pronunciation.bestScore': 'सर्वश्रेष्ठ स्कोर',
  'pronunciation.average': 'औसत',
  'pronunciation.attempts': 'प्रयास',
  'pronunciation.practiceAgain': 'फिर से अभ्यास करें',
  'pronunciation.changeLevel': 'स्तर बदलें',
  'pronunciation.tips': 'बेहतर उच्चारण के लिए सुझाव',
  'pronunciation.tip1': 'पहले ऑडियो सुनें',
  'pronunciation.tip2': 'स्पष्ट और स्थिर गति से बोलें',
  'pronunciation.tip3': 'कठिन शब्दों के लिए धीमा प्लेबैक उपयोग करें',
  'pronunciation.tip4': 'शांत वातावरण में अभ्यास करें',

  // ==================== VOCABULARY ====================
  'vocab.title': 'शब्दावली',
  'vocab.totalWords': 'कुल शब्द',
  'vocab.mastered': 'महारत',
  'vocab.dueToday': 'आज देय',
  'vocab.reviewSession': 'समीक्षा सत्र',
  'vocab.wordsDue': 'शब्द समीक्षा के लिए देय',
  'vocab.startReview': 'समीक्षा शुरू करें',
  'vocab.allCaughtUp': 'सब पूरा!',
  'vocab.noWordsDue': 'कोई शब्द समीक्षा के लिए देय नहीं',
  'vocab.sessionComplete': 'सत्र पूर्ण!',
  'vocab.allWords': 'सभी शब्द',

  // ==================== PROFILE ====================
  'profile.title': 'प्रोफ़ाइल',
  'profile.level': 'स्तर',
  'profile.xpToNext': 'अगले स्तर के लिए XP',
  'profile.totalXp': 'कुल XP',
  'profile.currentStreak': 'वर्तमान स्ट्रीक',
  'profile.lessonsDone': 'पूर्ण पाठ',
  'profile.timeLearned': 'सीखने का समय',
  'profile.achievements': 'उपलब्धियां',
  'profile.settings': 'सेटिंग्स',
  'profile.dailyGoals': 'दैनिक लक्ष्य',
  'profile.allAchievements': 'सभी उपलब्धियां',
  'profile.logOut': 'लॉग आउट',
  'profile.koreanLevel': 'कोरियाई स्तर',

  // ==================== SETTINGS ====================
  'settings.title': 'सेटिंग्स',
  'settings.language': 'ऐप भाषा',
  'settings.preferences': 'प्राथमिकताएं',
  'settings.sound': 'ध्वनि प्रभाव',
  'settings.soundEffects': 'ध्वनि प्रभाव',
  'settings.soundEffectsDesc': 'अभ्यास का जवाब देते समय ध्वनि बजाएं',
  'settings.notifications': 'सूचनाएं',
  'settings.notificationsDesc': 'दैनिक सीखने के अनुस्मारक प्राप्त करें',
  'settings.darkMode': 'डार्क मोड',
  'settings.darkModeDesc': 'आरामदायक देखने के लिए डार्क थीम',
  'settings.dailyReminder': 'दैनिक अनुस्मारक',
  'settings.account': 'खाता',
  'settings.editProfile': 'प्रोफ़ाइल संपादित करें',
  'settings.privacy': 'गोपनीयता',
  'settings.help': 'मदद',
  'settings.about': 'के बारे में',
  'settings.retakeTest': 'लेवल टेस्ट फिर से दें',
  'settings.retakeTestDesc': 'अपना वर्तमान कोरियाई स्तर जांचें',
  'settings.terms': 'सेवा की शर्तें',

  // ==================== FOOTER ====================
  'footer.privacy': 'गोपनीयता',
  'footer.terms': 'शर्तें',
  'footer.contact': 'संपर्क',
  'footer.rights': 'सर्वाधिकार सुरक्षित।',

  // ==================== QUICK ACTIONS ====================
  'quickAction.vocabulary': 'शब्दावली',
  'quickAction.reviewWords': 'शब्दों की समीक्षा करें',
  'quickAction.allCourses': 'सभी कोर्स',
  'quickAction.browseLessons': 'पाठ ब्राउज़ करें',

  // ==================== COURSE DETAIL ====================
  'courseDetail.notFound': 'कोर्स नहीं मिला',
  'courseDetail.lessons': 'पाठ',
  'courseDetail.completed': 'पूर्ण',

  // ==================== BOTTOM NAVIGATION ====================
  'bottomNav.home': 'होम',
  'bottomNav.courses': 'कोर्स',
  'bottomNav.vocab': 'शब्दावली',
  'bottomNav.profile': 'प्रोफ़ाइल',

  // ==================== AI TUTOR ====================
  'aiTutor.title': 'AI ट्यूटर',
  'aiTutor.selectScenario': 'एक परिदृश्य चुनें',
  'aiTutor.freeTalk': 'फ्री टॉक',
  'aiTutor.cafe': 'कैफे ऑर्डर',
  'aiTutor.shopping': 'शॉपिंग',
  'aiTutor.restaurant': 'रेस्तरां',
  'aiTutor.friends': 'दोस्त बनाना',
  'aiTutor.interview': 'नौकरी साक्षात्कार',
  'aiTutor.typeMessage': 'संदेश टाइप करें...',
  'aiTutor.send': 'भेजें',

  // ==================== ERRORS ====================
  'error.generic': 'कुछ गलत हो गया',
  'error.network': 'नेटवर्क त्रुटि। कृपया अपना कनेक्शन जांचें।',
  'error.notFound': 'पेज नहीं मिला',
  'error.unauthorized': 'जारी रखने के लिए कृपया लॉग इन करें',
  'error.microphoneAccess': 'माइक्रोफोन एक्सेस अस्वीकृत',
  'error.speechNotSupported': 'स्पीच रिकग्निशन समर्थित नहीं है। Chrome ब्राउज़र आज़माएं।',

  // ==================== COOKIE CONSENT ====================
  'cookie.title': 'हम कुकीज़ का उपयोग करते हैं',
  'cookie.description': 'हम आपके अनुभव को बेहतर बनाने, साइट ट्रैफ़िक का विश्लेषण करने और सामग्री को वैयक्तिकृत करने के लिए कुकीज़ का उपयोग करते हैं। आप गैर-आवश्यक कुकीज़ को स्वीकार या अस्वीकार कर सकते हैं।',
  'cookie.learnMore': 'और जानें',
  'cookie.acceptAll': 'सभी स्वीकार करें',
  'cookie.rejectAll': 'सभी अस्वीकार करें',
  // ==================== ADDED (i18n audit 2026-10-24) ====================
  'nav.learn': 'सीखें',
  'nav.culture': 'संस्कृति',
  'nav.chat': 'चैट',
  'nav.ranking': 'रैंकिंग',
  'nav.family': 'परिवार',
  'nav.premium': 'प्रीमियम',
  'home.greeting': 'नमस्ते',
  'home.streak': 'दिन की स्ट्रीक',
  'home.dailyGoal': 'दैनिक लक्ष्य',
  'home.myLanguages': 'मेरी भाषाएँ',
  'home.addLanguage': 'भाषा जोड़ें',
  'home.recommended': 'अनुशंसित',
  'home.continue': 'सीखना जारी रखें',
  'home.selectLanguage': 'भाषा चुनें',
  'home.totalXp': 'कुल XP',
  'home.bestStreak': 'सर्वश्रेष्ठ स्ट्रीक',
  'home.level': 'लेवल',
  'chat.aiTutor': 'AI ट्यूटर',
  'chat.aiTutorDesc': 'AI के साथ बातचीत का अभ्यास करें',
  'onboarding.welcome.subtitle': 'AI बातचीत के ज़रिए कोई भी भाषा सीखें',
  'onboarding.selectUILanguage': 'अपनी भाषा चुनें',
  'onboarding.selectUILanguage.subtitle': 'यह ऐप इंटरफ़ेस के लिए इस्तेमाल होगी',
  'onboarding.selectLearningLanguage': 'आप क्या सीखना चाहेंगे?',
  'onboarding.selectLearningLanguage.subtitle': 'आप कई भाषाएँ सीख सकते हैं',
  'onboarding.selectDailyGoal': 'अपना दैनिक लक्ष्य तय करें',
  'onboarding.selectDailyGoal.subtitle': 'हर दिन कितना समय दे सकते हैं?',
  'onboarding.ready': 'सब तैयार है!',
  'onboarding.ready.subtitle': 'चलिए आपकी भाषा सीखने की यात्रा शुरू करें',
  'onboarding.features.languages': '4 भाषाएँ',
  'onboarding.features.aiTutor': 'AI ट्यूटर',
  'onboarding.features.dailyGoals': 'दैनिक लक्ष्य',
  'dailyGoal.5min': '5 मिनट',
  'dailyGoal.10min': '10 मिनट',
  'dailyGoal.15min': '15 मिनट',
  'dailyGoal.20min': '20 मिनट',
  'dailyGoal.casual': 'आराम से',
  'dailyGoal.regular': 'नियमित अभ्यास',
  'dailyGoal.serious': 'गंभीर शिक्षार्थी',
  'dailyGoal.intense': 'गहन अभ्यास',
  'learn.title': 'सीखें',
  'learn.currentLevel': 'वर्तमान लेवल',
  'learn.noCoursesYet': 'जल्द आ रहा है!',
  'learn.noCoursesDescription': 'इस भाषा के कोर्स तैयार किए जा रहे हैं।',
  'learn.lessonsCompleted': 'पाठ पूरे हुए',
  'learn.startCourse': 'कोर्स शुरू करें',
  'learn.continueCourse': 'जारी रखें',
  'learn.courseCompleted': 'पूरा हुआ',
  'learn.locked': 'लॉक है',
  'learn.unlockBy': 'अनलॉक करने के लिए पिछला कोर्स पूरा करें',
  'course.progress': 'प्रगति',
  'course.lessons': 'पाठ',
  'course.lessonsCompleted': 'पाठ पूरे हुए',
  'course.noLessons': 'पाठ तैयार किए जा रहे हैं...',
  'lesson.tapToReveal': 'अर्थ देखने के लिए टैप करें',
  'lesson.examples': 'उदाहरण',
  'lesson.questionsCorrect': 'सही',
  'lesson.wordsLearned': 'शब्द',
  'lesson.grammarPoints': 'व्याकरण',
  'lesson.backToCourse': 'कोर्स पर वापस जाएँ',
  'lesson.practiceAgain': 'फिर से अभ्यास करें',
  'lesson.whatYouLearn': 'आप क्या सीखेंगे',
  'lesson.newWords': 'नए शब्द',
  'lesson.exercises': 'अभ्यास',
  'lesson.startLesson': 'पाठ शुरू करें',
  'lesson.reviewLesson': 'पाठ दोहराएँ',
  'lesson.learnVocabulary': 'शब्दावली सीखें',
  'lesson.grammarPoint': 'व्याकरण बिंदु',
  'lesson.practice': 'अभ्यास',
  'profile.guest': 'अतिथि',
  'profile.days': 'दिन',
  'profile.longestStreak': 'सबसे लंबी',
  'profile.lessonsCompleted': 'पूरे हुए',
  'profile.dailyGoal': 'दैनिक लक्ष्य',
  'profile.learningLanguages': 'सीखी जा रही भाषाएँ',
  'profile.noLanguages': 'कोई भाषा नहीं चुनी गई',
  'profile.minutesPerDay': 'मिनट/दिन',
  'profile.learningHistory': 'सीखने का इतिहास',
  'profile.viewProgress': 'अपनी प्रगति देखें',
  'profile.appSettings': 'ऐप सेटिंग्स',
  'profile.languageNotifications': 'भाषा, सूचनाएँ',
  'profile.loginToSave': 'अपनी प्रगति सहेजने के लिए लॉग इन करें',
  'settings.learning': 'सीखना',
  'settings.dailyGoal': 'दैनिक लक्ष्य',
  'settings.minutesPerDay': 'मिनट प्रतिदिन',
  'settings.selectLanguage': 'भाषा चुनें',
  'settings.selectDailyGoal': 'दैनिक लक्ष्य तय करें',
  'settings.perDay': 'प्रतिदिन',
  'settings.appInfo': 'ऐप जानकारी',
  'settings.logout': 'लॉग आउट',
};

export default hi;
